import { Button } from 'react-bootstrap';
import { FaLocationCrosshairs } from 'react-icons/fa6';
import CustomLeafletControl from './CustomLeafletControl';

const MapReset = ({ onClick, interacted }) => {
  return (
    <CustomLeafletControl position="topleft">
      {interacted && (
        <div className="leaflet-bar bg-white">
          <Button
            variant="light"
            onClick={onClick}
            style={{
              width: 30,
              height: 30,
              padding: 0,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FaLocationCrosshairs size={18} style={{ color: '#222' }} />
          </Button>
        </div>
      )}
    </CustomLeafletControl>
  );
};

export default MapReset;
